export const defaultCustomer = {
  shortname: "",
  name: "No Company",
  logo: null,
};
